import React from 'react';

const Services: React.FC = () => {
  const services = [
    {
      title: 'Software Solutions',
      description: 'Providing end-to-end development of responsive web and mobile applications, ensuring scalability, performance, and seamless user experience.',
      icon: '💻'
    },
    {
      title: 'ITaaS (IT as a Service)',
      description: 'Delivering flexible, on-demand IT solutions, including infrastructure management, system integration, and technical support, tailored to your business needs.',
      icon: '⚙️'
    },
    {
      title: 'IoT Solutions',
      description: 'Enabling smart connectivity with innovative IoT solutions, integrating hardware and software for seamless data-driven decision-making.',
      icon: '🌐'
    }
  ];

  return (
    <section id="services">
      <div className="container">
        <h2>Our Services</h2>
        <div className="service-list">
          {services.map((service, index) => (
            <div key={index} className="service-item">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 